<template>
  <v-container>
    <Loading v-model="loading"></Loading>

    <h2>（２）科目選択</h2>
    <v-form ref="form">
      <v-container>
        <p class="text-caption-scoped text-left">
          プルダウンより受験外国語を選択してください。<br>
          ※中国語受験の方は中国語選択後、下部に表示される「簡体字・繁体字」を選択してください。（中国語の免除申請をされる方は選択不要です。）<br>
          ※受験を希望する二カ国語の内、１つ以上の外国語科目が免除となる場合のみ二カ国語受験が可能です。<br>
          <span class="font-weight-bold red--text">※免除申請する外国語は右側の「免除申請」にチェックを入れてください。</span>
        </p>
        <v-row>
          <v-col>
            <v-select label="受験外国語"
                      v-model="form.language1"
                      :items="languageOptions1"
                      :disabled="submitted"
                      :rules="[rules.required]"></v-select>
          </v-col>
          <v-col cols="2">
            <v-checkbox label="免除申請"
                        v-model="requestFirstLanguageExemption"
                        :disabled="submitted && !requiredResubmit"
                        v-if="form.language1"
                        @change="handleFirstLanguageExemptionChange"
            ></v-checkbox>
          </v-col>
        </v-row>
        <p class="text-caption-scoped text-left">
          ※二カ国語受験で口述試験のみ受験する第二外国語を入力してください。また、<span class="red--text">受験第二外国語は免除申請が必須です。</span>
          右側の「免除申請」にチェックを入れ、ページ下部の<span class="red--text">（４）免除科目申請において、受験第二外国語の免除申請書類を添付して提出してください。</span>
        </p>
        <v-row>
          <v-col>
            <v-select label="受験第二外国語"
                      v-model="form.language2"
                      :disabled="submitted"
                      :items="languageOptions2"></v-select>
          </v-col>
          <v-col cols="2">
            <v-checkbox label="免除申請"
                        v-model="requestSecondLanguageExemption"
                        :rules="[rules.required]"
                        :disabled="submitted && !requiredResubmit"
                        v-if="form.language2"
                        @change="handleSecondLanguageExemptionChange"
                        ></v-checkbox>

          </v-col>
        </v-row>

        <v-radio-group v-if="selectChinese" v-model="form.chineseType"
                       :rules="[selectChineseRule]"
                       :disabled="submitted" row>
          <template v-slot:label> 中国語を受験する方</template>
          <v-radio label="簡体字" value="簡体字"></v-radio>
          <v-radio label="繁体字" value="繁体字"></v-radio>
        </v-radio-group>

        <p class="text-caption-scoped text-left">
          <span class="font-weight-bold red--text">※免除申請する日本語科目は右側の「免除申請」にチェックを入れてください。</span>
        </p>

        <v-row v-for="s in nonLanguageSubjects" :key="s.id">
          <v-col>
            <v-text-field :value="s.title" readonly outlined dense></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-checkbox label="免除申請" :value="s.id" v-model="requestOtherSubjectExemption"
                        :disabled="submitted && !requiredResubmit"></v-checkbox>
          </v-col>
        </v-row>

        <h2>（３）希望受験地</h2>
        <p class="text-caption-scoped text-left">
          ※受験外国語により選択できる受験地が異なります。施行要領P8をご確認の上、選択してください。<br>
          <strong>※筆記試験５科目すべてを免除申請する方は「免除」を選択してください。</strong>
        </p>

        <v-select label="筆記試験受験地" v-model="form.writtenExamArea" :items="writtenExamAreasOptions"
                  :disabled="submitted && !requiredResubmit"
                  :rules="[rules.required, writtenExamAreaRule]">
        </v-select>
        <v-select label="口述試験受験地" v-model="form.oralExamArea" :items="oralExamAreasOptions"
                  :disabled="submitted && !requiredResubmit"
                  :rules="[rules.required, oralExamAreaRule]"></v-select>

        <h2>（４）免除科目申請</h2>

        <p class="text-caption-scoped text-left">
          ※免除を希望される場合は、下記手順で必ず申請をしてください。<br>
          ※過去に免除申請を行った方も、<span class="font-weight-bold red--text">今年度の試験で免除を希望される場合は、改めて申請が必要です。</span><br>
          <br>
          <span class="caption-title">【免除科目申請手順】</span><br>
          ①免除科目申請をする「申請の種類」の左側「申請」チェックボックスにチェックを入れてください。<br>
          <span class="red--text font-weight-bold">　※免除申請する科目については、必ず上部の（２）科目選択において、該当科目の右側の「免除申請」にチェックを入れてください。</span><br>
          ②必要な添付書類、入力項目のご案内が表示されます。表示された書類のアップロード、項目の入力をしてください。<br>
          ③ページ下部「確定する」ボタンをクリック<br>
          　※登録内容に不備がない場合は、画面上部に「確定しました」と表示が出て、マイページに移動します。<br>
          　※表示が出ない場合は、必須項目に未入力・未登録の項目があります。<br>
          　　該当箇所に赤字で不備内容が表示されますので、表示を確認の上、全て入力・登録をしてください。<br>
          <br>
          <span class="caption-title">【免除書類のアップロード手順】</span><br>
          ①クリップマークをクリック<br>
          ②免除科目申請に必要な書類のファイルを選択しアップロード<br>
          ③ファイルのアップロードが完了すると、クリップマークの上にアップロードしたファイル名が表示される<br>
          ④ファイルを複数アップロードする場合は②～④の操作を繰り返す<br>
          ※１ファイル20MBまで。<span style="color: red; font-weight: bold;">画像ファイルはJPEGまたはPDF形式でアップロードをお願いいたします。</span>
        </p>

        <v-data-table class="text-left exemptions-table"
                      :headers="tableHeader"
                      :items="filteredExemptions"
                      :expanded="expandedItems"
                      :items-per-page="-1"
                      item-key="id"
                      hide-default-footer>
          <template v-slot:item.id="{item}">
            <!-- No.4 「前年度合格科目免除」の申請項目追加:免除申請の選択状態を監視 -->
            <v-checkbox v-model="form.exemptions" :value="item.id"
                        :disabled="submitted && !requiredResubmit"
                        @change="handleCheckboxChange(item.title)"
            ></v-checkbox>
          </template>
          <template v-slot:item.target="{item}">
            <div v-html="item.target" class="text-pre-wrap"></div>
          </template>
          <template v-slot:expanded-item="{headers, item}">
            <td :colspan="headers.length" class="pa-5">

              <p class="text-caption-scoped text-left text-pre-line" v-html="item.documents"></p>

              <template v-if="form.exemptions.includes(item.id) && !!item.schema">
                <!-- No4 「前年度合格科目免除」の申請項目追加 -->
                <v-checkbox label="外国語（チェックを外す時は、先に「×」で表示内容（外国語又はハイフン）を削除してください。）"
                        v-if="item.title === '前年度一部合格科目免除'"
                        v-model="form.qualifiedForeignLanguageSelection"
                        :disabled="submitted && !requiredResubmit"
                        @change="updateSchemaReadOnly(item, !form.qualifiedForeignLanguageSelection)"
                        ></v-checkbox>

                <v-jsf :schema="item.schema"
                       :options="vjsfOptions"
                       v-model="form.exemptionData[item.id]">
                  <template v-slot:観光庁研修終了証明書="{label}">
                    <span v-for="item in getExemptionFiles(item.id)" :key="item.fileId" class="mr-1">
                      <v-chip :href="item.url"
                              :close="!submitted || requiredResubmit"
                              @click:close="removeFromExemptionFiles(item)">
                        {{ item.key|fileName }}
                        </v-chip>
                    </span>
                    <v-file-input show-size
                                  :label="label"
                                  required
                                  multiple
                                  :disabled="submitted && !requiredResubmit"
                                  :rules="[rules.files(item.id)]"
                                  @change="upload($event, item.id)"></v-file-input>
                  </template>
                  <template v-slot:ファイルアップロード="{label}">
                    <span v-for="item in getExemptionFiles(item.id)" :key="item.fileId" class="mr-1">
                      <v-chip :href="item.url"
                              :close="!submitted || requiredResubmit"
                              @click:close="removeFromExemptionFiles(item)">
                        {{ item.key|fileName }}
                        </v-chip>
                    </span>
                    <v-file-input show-size
                                  :label="label"
                                  required
                                  multiple
                                  :disabled="submitted && !requiredResubmit"
                                  :rules="[rules.files(item.id)]"
                                  @change="upload($event, item.id)"></v-file-input>
                  </template>
                </v-jsf>
              </template>

              <template v-else-if="form.exemptions.includes(item.id)">
                <span v-for="item in getExemptionFiles(item.id)" :key="item.fileId" class="mr-1">
                  <v-chip :href="item.url"
                          :close="!submitted || requiredResubmit"
                          @click:close="removeFromExemptionFiles(item)">
                    {{ item.key|fileName }}
                    </v-chip>
                </span>
                <v-file-input show-size
                              label="ファイルアップロード"
                              required
                              multiple
                              :disabled="submitted && !requiredResubmit"
                              :rules="[rules.files(item.id)]"
                              @change="upload($event, item.id)"></v-file-input>
              </template>
            </td>
          </template>
        </v-data-table>

        <p class="text-caption-scoped text-left d-inline-block my-8">
          ※「確定する」ボタンをクリックしても画面上部に「確定しました」と表示が出ない場合は、<br/>
          必須項目に未入力・未登録の項目があります。<br/>
          該当箇所に赤字で不備内容が表示されますので、表示を確認の上、全て入力・登録をしてください。<br/>
          ※願書提出後の「受験科目、選択外国語、受験地、免除申請」の変更・追加はできません。<br/>
          <span class="red--text font-weight-bold">※入力内容や申請内容に不備があった場合は再提出となります。期日までに申請不備が<br/>
          解消されない場合は申込申請を受理することができません。入力内容に誤りが無い<br/>
            か再度確認してください。</span>
        </p>

        <div class="text-center">
          <v-btn to="/mypage" class="mx-2">マイページに戻る</v-btn>
          <v-btn @click.stop="save" class="mx-2" v-if="!submitted">保存する</v-btn>
          <v-btn color="primary" @click.stop="submit" class="mx-2" v-if="!submitted || requiredResubmit">確定する</v-btn>
        </div>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>

import axios from 'axios'
import Loading from '../components/Loading'
import VJsf from '@koumoul/vjsf/lib/VJsf.js'
import Rules from '../mixins/RulesMixin'
import SubjectSelection from '../mixins/SubjectSelection'
import _ from 'lodash';


export default {
  components: {Loading, VJsf},
  mixins: [Rules, SubjectSelection],
  data() {
    return {
      loading: true,
      form: {
        language1: '',
        language2: '',
        chineseType: '',
        requestedSubjects: [],
        exemptions: [],
        exemptionFiles: [],
        exemptionData: {},
        writtenExamArea: '',
        oralExamArea: '',
        data: {},
        qualifiedForeignLanguageSelection: false,
        requestOtherSubjectExemptionTitle: [],
      },
      isCheckedPrevYearPartialExemption: false,
      isCheckedPrevYearFiveSubjectExemption: false,
      prevYearPartialExemptionTitle: '前年度一部合格科目免除',
      prevYearFiveSubjectExemptionTitle: '前年度5科目合格者免除',
      // No.11 願書再提出ボタンの改修:編集前のformの格納
      draftForm: {
        language1: '',
        language2: '',
        chineseType: '',
        requestedSubjects: [],
        exemptions: [],
        exemptionFiles: [],
        exemptionData: {},
        writtenExamArea: '',
        oralExamArea: '',
        data: {},
        qualifiedForeignLanguageSelection: false,
        requestOtherSubjectExemptionTitle: [],
      },
      schemaData: [],
      expanded: [],
      tableHeader: [
        {text: '申請', value: 'id', sortable: false},
        {text: '申請の種類', value: 'title', sortable: false},
        {text: '科目', value: 'subjectName', sortable: false},
        {text: '免除対象者', value: 'target', sortable: false},
        // {text: '提出書類', value: 'documents'},
        {text: '免除申請有効期限有無', value: 'hasExpired', sortable: false},
        {text: '免除申請有効期限', value: 'expiredAt', sortable: false}
      ],
      writtenExamAreaRule: (v) => !!v || (this.canAvoidWrittenExam && v === 0) || "必須項目です",
      oralExamAreaRule: (v) => this.oralExamAreasOptions.some(a => a.value == v) || "必須項目です",
      selectChineseRule: (v) => !!v || !this.selectChinese || "必須項目です",
    }
  },
  async created() {
    await this.fetchSubjects()
    await this.fetchSaved()
    this.loading = false
    //No.4 「前年度合格科目免除」の申請項目追加：画面Mountする時にチェックボックス選択状態をチェック
    this.handleCheckboxChange(this.prevYearPartialExemptionTitle)
    this.handleCheckboxChange(this.prevYearFiveSubjectExemptionTitle)
  },
  computed: {
    prevYearPartialExemptionId () {
      const target = (this.filteredExemptions || []).find(
    item => item.title === this.prevYearPartialExemptionTitle
  ) ??
  (this.expandedItems || []).find(
    item => item.title === this.prevYearPartialExemptionTitle
  )
      return target?.id || 0
    },
    prevYearFiveSubjectExemptionId () {
      const target = (this.filteredExemptions || []).find(
    item => item.title === this.prevYearFiveSubjectExemptionTitle
  ) ??
  (this.expandedItems || []).find(
    item => item.title === this.prevYearFiveSubjectExemptionTitle
  )
      return target?.id || 0
    },
    // No.11 願書再提出ボタンの改修:編集状態をチェック
    hasChanged () {
      return !_.isEqual(this.draftForm,this.form)
    },
    submitted() {
      return this.$store.getters.submitted
    },
    requiredResubmit() {
      return this.$store.getters.requiredResubmit
    },
    uploadedSubjects() {
      return this.form.exemptions.map(value => {
        return this.exemptions.find(v => v.id == value)
      }).map(v => {
        if (v.schema && v.schema["x-function"]) {
          let model = this.form.exemptionData[v.id] || {}
          try {
            let f = new Function(v.schema["x-function"]["arguments"], v.schema["x-function"]["body"])
            return f(model)
          } catch (e) {
            console.error(e)
          }
        }
        switch (v.subjectName) {
          case '仏語':
            return "フランス語";
          case '西語':
            return "スペイン語";
          case '独語':
            return "ドイツ語";
          case '伊語':
            return "イタリア語";
        }
        return v.subjectName
      }).flat()
    },
    documentRequiredSubjects() {
      return this.requestedSubjects.map(s => this.subjects.find(v => v.id == s))
    },
    lackedDocumentSubjects() {
      return this.documentRequiredSubjects.filter(s => {
        return !this.uploadedSubjects.some(value => value === s.title)
      }).map(s => s.title)
    },
    validateRequiredDocuments() {
      return this.documentRequiredSubjects.every(s => {
        return this.uploadedSubjects.some(value => value === s.title)
      })
    },
  },
  watch: {
    requestOtherSubjectExemption: {
    handler(newValue) {
      this.requestOtherSubjectExemptionTitle = this.nonLanguageSubjects
        .filter((s) => newValue.includes(s.id))
        .map((s) => s.title);
    },
    deep: true,
  }
  },
  methods: {
    //No.4 「前年度合格科目免除」の申請項目追加:チェック状態付与
    handleCheckboxChange(title) {
      if (title == this.prevYearPartialExemptionTitle) {
        this.isCheckedPrevYearPartialExemption = this.form.exemptions.includes(this.prevYearPartialExemptionId)
      }
      if (title == this.prevYearFiveSubjectExemptionTitle) {
        this.isCheckedPrevYearFiveSubjectExemption = this.form.exemptions.includes(this.prevYearFiveSubjectExemptionId)
      }
      this.filteredExemptionsAddReadOnly()
  },

  //No.4 「前年度合格科目免除」の申請項目追加:チェックしないと、外国語のドロップダウン無効にする
  filteredExemptionsAddReadOnly() {
    let isAddReadOnlyExecuted = false
        this.filteredExemptions.forEach(item => {
          if (item.schema && item.schema.properties) {
            this.addReadOnlyToProperties(item)
            isAddReadOnlyExecuted = true
          }
        })

        if (!isAddReadOnlyExecuted) {
          this.expandedItems.forEach(item => {
          if (item.schema && item.schema.properties) {
            this.addReadOnlyToProperties(item)
          }
        })
      }
  },
  //No.4 「前年度合格科目免除」の申請項目追加:チェックしないと、外国語のドロップダウン無効にする
  handleFirstLanguageExemptionChange(newValue) {
      this.filteredExemptionsAddReadOnly()
  },
  //No.4 「前年度合格科目免除」の申請項目追加:チェックしないと、外国語のドロップダウン無効にする
  handleSecondLanguageExemptionChange(newValue) {
    this.filteredExemptionsAddReadOnly()
  },

  //No.4 「前年度合格科目免除」の申請項目追加:自動生成のinputの状態を更新
    updateSchemaReadOnly(item, readOnlyValue) {
    if (item && item.schema && item.schema.properties) {
      const properties = item.schema.properties
      for (const key in properties) {
        if (key == '外国語' && properties.hasOwnProperty(key) && item.title == this.prevYearPartialExemptionTitle) {
          this.$set(properties[key], 'readOnly', readOnlyValue)
        }
      }
    }
  },

  //No.4 「前年度合格科目免除」の申請項目追加:チェックしないと、外国語のドロップダウン無効にする
  addReadOnlyToProperties(item) {
      for (const key in item.schema.properties) {
        if (key == '外国語' && item.schema.properties.hasOwnProperty(key) && item.title == this.prevYearPartialExemptionTitle) {
          this.$set(item.schema.properties[key], 'readOnly', this.form.qualifiedForeignLanguageSelection ? false : true)
        }
      }
    },
    getLanguageText(languageOptions, languageValue) {
    const matchedOption = languageOptions.find(option => option.value === languageValue)
    return matchedOption ? matchedOption.text : ''
  },

  //No.1 前年度合格番号との認証機能:前年度一部合格科目免除の外国語idと一部科目のidを取得
  processExemptionDataPrevYearPartialExemption() {
  const examNumber = this.form.exemptionData[this.prevYearPartialExemptionId]?.受験番号
  const otherSubjects = this.form.exemptionData[this.prevYearPartialExemptionId]?.その他科目 || []
  const foreignLanguage = this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語
  const matchedIds = otherSubjects?.map(subject => {
    const matchedSubject = this.nonLanguageSubjects.find(item => item.title === subject)
    return matchedSubject ? matchedSubject.title : null
  }).filter(title => title !== null)
  const matchedLanguageValue = this.languageOptions1.find(option => option.text === foreignLanguage)?.text || null
  if (matchedLanguageValue !== null) {
    matchedIds.push(matchedLanguageValue)
  }

  return {
    examNumber,
    mergedIds: matchedIds
  }
},

//No.1 前年度合格番号との認証機能:前年度5科目合格者免除の外国語idを取得
processExemptionDataPrevYearFiveSubjectExemption() {
  const examNumber = this.form.exemptionData[this.prevYearFiveSubjectExemptionId]?.受験番号
  const foreignLanguage = this.form.exemptionData[this.prevYearFiveSubjectExemptionId]?.外国語
  const matchedLanguageValue = this.languageOptions1.find(option => option.text === foreignLanguage)?.text || null
  const matchedIds = [`日本地理`, `日本歴史`, `一般常識`, `通訳案内の実務`]
  if (matchedLanguageValue !== null) {
    matchedIds.push(matchedLanguageValue)
  }
  return {
    examNumber,
    mergedIds: matchedIds
  }
},


    handleKeyChange(key, value) {
      console.log(`Handling key: ${key}, value:`, value)
    },
    isEqual(obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2)
    },

    //No.1 前年度合格番号との認証機能:API呼び出し
    // async fetchExamResultCheck(certificateNo, subjects) {
    //   try {
    //     //前年度
    //     const eventId = Number(this.$store.state.event.id) - 1
    //     const birthdate = this.$store.state.me.entry.birthdate
    //     const subjectsString = subjects.join(',')
    //     console.log("subjectsString",subjectsString)
    //     let { data } = await axios.get(`/api/exam/result/${eventId}/${certificateNo}`, {
    //       params: {
    //         birthdate: birthdate,
    //         subjects: subjectsString
    //       },
    //     })
    //     const resultKey = Object.keys(data)[0]
    //     const resultMessage = data[resultKey]
    //     return {
    //        success: resultKey === "true",
    //        message: resultMessage
    //       }
    //   } catch (error) {
    //     console.error("error:", error)
    //     throw error
    //   }
    // },
    async fetchSaved() {
      let {data} = await axios.get('/api/subject/draft')
      if (data) {
        this.form = Object.assign(this.form, data)

        this.schemaData = this.form.exemptionData

        if (data.language1 && data.requestedSubjects.includes(data.language1)) {
          this.requestFirstLanguageExemption = true
        }
        if (data.language2 && data.requestedSubjects.includes(data.language2)) {
          this.requestSecondLanguageExemption = true
        }

        //No.3 「前年度合格科目免除」の申請項目改修
        if ((this.requestFirstLanguageExemption || this.requestSecondLanguageExemption) && this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語) {
          this.form.qualifiedForeignLanguageSelection = true
        } else {
          this.form.qualifiedForeignLanguageSelection = false
        }
        this.filteredExemptionsAddReadOnly()
        this.requestOtherSubjectExemption = this.nonLanguageSubjects
          .filter(v => data.requestedSubjects.includes(v.id))
          .map(v => v.id)
        // No.11 願書再提出ボタンの改修:編集前のformをdeepcopy
        this.draftForm = _.cloneDeep(this.form)
      }
    },
    async upload(file, exemptionId) {
      if (!file) {
        this.form.exemptionFiles = this.form.exemptionFiles.filter(v => v.id != exemptionId)
        return
      }
      if (Array.isArray(file)) {
        this.loading = true
        try {
          for (let i in file) {
            await this.upload(file[i], exemptionId)
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false
        return
      }
      if (file.size > 20971520) {
        alert('ファイルサイズは20MB以下でアップロードしてください')
        return
      }
      let params = new FormData()
      params.append('file', file)
      let {data} = await axios.post('/api/visitor/file/upload', params)
      this.form.exemptionFiles =[...this.form.exemptionFiles,{
        id: exemptionId,
        fileId: data.id,
        key: file.name
      }]
    },
    getExemptionFile(id) {
      return this.form.exemptionFiles.find(v => v.id == id)
    },
    getExemptionFiles(id) {
      return this.form.exemptionFiles.filter(v => v.id == id)
    },
    getExemptionFileUrl(id) {
      let f = this.getExemptionFile(id)
      return f && f.url
    },
    removeFromExemptionFiles(item) {
      this.form.exemptionFiles = this.form.exemptionFiles.filter(v => v.fileId != item.fileId)
    },
    async save() {
      try {
        this.form.requestedSubjects = this.requestedSubjects
        this.form.chineseType = this.selectChinese ? this.form.chineseType : ""
        await axios.post('/api/subject/save', this.form)
        this.$emit('toast', '保存しました')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    },
    async submit() {
      try {
      if (this.submitted && !this.hasChanged) {
        this.$emit('error', '前回提出時の内容に対して、修正・変更がない状態での提出。')
        return
      }
        if (!this.$refs.form.validate()) {
          this.$emit('error', '入力項目にエラーがあります')
          return
        }
        if (!this.validateRequiredDocuments) {
          this.$emit('error', '免除書類に不足があります: ' + this.lackedDocumentSubjects.join(', '))
          return
        }
        if (this.requestFirstLanguageExemption ||this.requestSecondLanguageExemption || (this.requestOtherSubjectExemptionTitle?.length ?? 0) > 0) {
          //No.3 「前年度合格科目免除」の申請項目改修
        if (this.isCheckedPrevYearPartialExemption) {

          if (this.requestFirstLanguageExemption || this.requestSecondLanguageExemption) {
          if (!this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語 && this.form.qualifiedForeignLanguageSelection) {
            this.$emit('error', '外国語を選択してください。')
            return
          }
          if (this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語 && !this.form.qualifiedForeignLanguageSelection) {
            this.$emit('error', '外国語チェックボックスが選択されていません。')
            return
          }
        }

        //No.3 「前年度合格科目免除」の申請項目改修:外国語ドロップダウンのチェック
        if (this.form.qualifiedForeignLanguageSelection&&
        !this.requestFirstLanguageExemption &&
        !this.requestSecondLanguageExemption) {
          this.$emit('error',`前年度一部合格科目免除の申請がございません。申請箇所に✔をいれて再度申請ください。`)
          return
        }

         //No.3 「前年度合格科目免除」の申請項目改修:その他科目のチェック
      if (this.form.exemptionData[this.prevYearPartialExemptionId]?.その他科目) {
        const tempArray = this.form.exemptionData[this.prevYearPartialExemptionId]?.その他科目 || []
        const unmatchedItems = tempArray.filter(item => !this.requestOtherSubjectExemptionTitle.includes(item))
        if (unmatchedItems.length > 0) {
          this.$emit('error',`前年度一部合格科目免除の申請がございません。申請箇所に✔をいれて再度申請ください。`)
          return
        }
      }
     }

      //No.3 「前年度合格科目免除」の申請項目改修:前年度一部合格合格者免除に、外国語のチェック
      if (this.isCheckedPrevYearPartialExemption) {
      if (this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語) {
            let languageText1 = ''
            let languageText2 = ''
            if (this.requestFirstLanguageExemption) {
              languageText1 = this.getLanguageText(this.languageOptions1, this.form.language1)
            }

            if (this.requestSecondLanguageExemption) {
              languageText2 = this.getLanguageText(this.languageOptions2, this.form.language2)
            }
            if (this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語 !== languageText1 &&  this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語 !== languageText2) {
              this.$emit('error',`前年度一部合格科目免除の申請がございません。申請箇所に✔をいれて再度申請ください。`)
              return
            }
        }
     }

      //No.3 「前年度合格科目免除」の申請項目改修:前年度5科目合格者免除に、外国語のチェック
     if (this.isCheckedPrevYearFiveSubjectExemption) {
      if (this.form.exemptionData[this.prevYearFiveSubjectExemptionId]?.外国語) {
            if (!this.requestFirstLanguageExemption &&
            !this.requestSecondLanguageExemption) {
              this.$emit('error',`前年度5科目合格者免除の申請がございません。申請箇所に✔をいれて再度申請ください。`)
              return
            }
            let languageText1 = ''
            let languageText2 = ''
            if (this.requestFirstLanguageExemption) {
              languageText1 = this.getLanguageText(this.languageOptions1, this.form.language1)
            }

            if (this.requestSecondLanguageExemption) {
              languageText2 = this.getLanguageText(this.languageOptions2, this.form.language2)
            }

            if (this.form.exemptionData[this.prevYearFiveSubjectExemptionId]?.外国語 !== languageText1 &&  this.form.exemptionData[this.prevYearFiveSubjectExemptionId]?.外国語 !== languageText2) {
              this.$emit('error',`前年度5科目合格者免除の申請がございません。申請箇所に✔をいれて再度申請ください。`)
              return
            }
        }
     }

     //No.1 前年度合格番号との認証機能:前年度一部合格科目免除のチェック
     const resultPrevYearPartialExemption = this.processExemptionDataPrevYearPartialExemption()
     if (resultPrevYearPartialExemption.examNumber && this.isCheckedPrevYearPartialExemption) {
      if (resultPrevYearPartialExemption.mergedIds.length === 0) {
        this.$emit('error', '外国語を選択してください。')
        return
      }
    //   try {
    //   const result = await this.fetchExamResultCheck(resultPrevYearPartialExemption.examNumber, resultPrevYearPartialExemption.mergedIds)
    //   if (!result.success) {
    //   this.$emit('error', result.message)
    //   return
    //   }
    // } catch (error) {
    //   console.error("error:", error)
    //   return
    // }
     }
     //No.1 前年度合格番号との認証機能:前年度5科目合格者免除のチェック
    const resultPrevYearFiveSubjectExemption = this.processExemptionDataPrevYearFiveSubjectExemption()
     if (resultPrevYearFiveSubjectExemption.examNumber && this.isCheckedPrevYearFiveSubjectExemption) {
      if (resultPrevYearFiveSubjectExemption.mergedIds.length === 0) {
        this.$emit('error', '外国語を選択してください。')
        return
      }
    //   try {
    //   const result = await this.fetchExamResultCheck(resultPrevYearFiveSubjectExemption.examNumber, resultPrevYearFiveSubjectExemption.mergedIds)
    //   if (!result.success) {
    //   this.$emit('error', result.message)
    //   return
    //   }
    // } catch (error) {
    //   console.error("error:", error)
    //   return
    // }
     }
        }

        if (!this.form.qualifiedForeignLanguageSelection && this.form.exemptionData[this.prevYearPartialExemptionId]?.外国語) {
          delete this.form.exemptionData[this.prevYearPartialExemptionId]?.["外国語"]
        }

        this.form.requestedSubjects = this.requestedSubjects
        this.form.chineseType = this.selectChinese ? this.form.chineseType : ""
        await axios.post('/api/subject/submit', this.form)
        this.$emit('toast', '確定しました')
        await this.$router.push('/mypage')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    },
  }
}
</script>
<style scoped>
v-simple-table {
  text-align: left;
}

.caption-title {
  text-align: left;
  font-size: 130%;
  font-weight: bold;
  /*color: #959595;*/
}
</style>
<style>
.exemptions-table .v-data-table-header th{
  min-width: 100px;
}
</style>
